export default {
    gutter: '30px',
};
